export type RegisterInput = {
  token: string;
  email: string;
};
